export default __webpack_public_path__ + "static/media/equilibrio-05.f065a4e1.jpg";